import React from "react";
import { Shield, RefreshCcw, Battery } from "lucide-react";

const BatteryTypes: React.FC = () => {
  const cardsData = [
    {
      icon: RefreshCcw,
      title: "Waste to Raw material creation",
      points: [
        {
          // head: "Control technology of carbon electrode",
          head: "Proprietary processes to convert industrial waste and slag into next generation advanced  nano-material.",
          desc: "Achieving different battery performance, meeting customized requirements of customers.",
        },
        {
          // head: "Catalyst technology with wide operating temperature range",
          head: "Closed-loop material engineering to reduce import dependency and critical mineral usage.",
          desc: "The battery performs well in −60°C to 100°C. Self-discharge ≤1%. Life expectancy > 20 years.",
        },
      ],
    },
    {
      icon: Battery,
      title: "Enhanced LFP",
      points: [
        {
          head: "Reinforced LFP electrodes for superior electron mobility and thermal stability.",
          desc: "High voltage (≥4.4V). Innovative structure. Fast charge: 1 min charge = 1 hr listen.",
        },
        {
          head: "Delivers high C-rate performance with reduced internal resistance.",
          desc: "High voltage (≥4.45V). 3C–10C fast charge.",
        },
        {
          head: "Fast-Charge & Long-Cycle Life",
          desc: "High voltage (≥4.4V). Fast charge. Low self-discharge.",
        },
      ],
    },
  ];

  return (
    <section id="technology" className="w-full bg-white py-8 sm:py-12 lg:py-10 border-t border-gray-200">
      <div className="container mx-auto px-4 sm:px-36 lg:px-40">
        <div className="mb-8 sm:mb-12 lg:mb-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-base text-sky-500 text-center">
            Technology
          </h2>
        </div>
        
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {cardsData.map((card, index) => {
            const Icon = card.icon;

            return (
              <div
                key={index}
                className="
                  group relative rounded-lg sm:rounded-xl lg:rounded-2xl overflow-hidden 
                  p-4 sm:p-6 md:p-8 lg:p-10 shadow-sm border border-gray-200
                  bg-white hover:bg-gradient-to-b hover:from-sky-500 hover:to-sky-400
                  transition-all duration-500 ease-in-out
                  hover:shadow-xl hover:-translate-y-1
                "
              >
                <Icon
                  className="
                    absolute -bottom-8 -right-8 w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 lg:w-64 lg:h-64 
                    opacity-20 text-gray-200
                    transition-all duration-500
                    group-hover:text-white group-hover:opacity-10
                    group-hover:scale-110
                  "
                />

                <div className="mb-3 sm:mb-4 md:mb-6">
                  <Icon
                    className="
                      w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 
                      text-sky-500
                      transition-colors duration-500
                      group-hover:text-white
                    "
                  />
                </div>

                <h3
                  className="
                    text-xl sm:text-2xl md:text-3xl font-semibold leading-tight text-gray-900
                    transition-colors duration-500
                    group-hover:text-white
                    mb-4 sm:mb-6
                  "
                >
                  {card.title}
                </h3>

                <ul className="space-y-3 sm:space-y-4 md:space-y-6">
                  {card.points.map((pt, i) => (
                    <li key={i}>
                      <div className="flex items-start gap-2 sm:gap-3">
                        <span
                          className="
                            text-sky-500 text-xl sm:text-2xl md:text-3xl leading-none mt-1
                            transition-colors duration-500
                            group-hover:text-white
                            flex-shrink-0
                          "
                        >
                          •
                        </span>
                        <div>
                          <p
                            className="
                              font-medium text-gray-900 text-sm sm:text-base md:text-lg
                              transition-colors duration-500
                              group-hover:text-white
                              mb-1
                            "
                          >
                            {pt.head}
                          </p>
                          <p
                            className="
                              text-gray-600 text-xs sm:text-sm leading-relaxed
                              transition-colors duration-500
                              group-hover:text-white/90
                            "
                          >
                            {/* {pt.desc} */}
                          </p>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BatteryTypes;